import { Component, OnInit } from '@angular/core';
import {LangChange} from "../../../../lang-change";
import {Language} from "../../../../common/models/language";
import {TranslateService} from '@ngx-translate/core';
import {NewsSharedService} from "../../../common-main/services/news-shared.service";
import {Router} from '@angular/router';

@Component({
  selector: 'app-news-list-tabs',
  templateUrl: './news-list-tabs.component.html',
  styleUrls: ['./news-list-tabs.component.scss']
})
export class NewsListTabsComponent extends LangChange implements OnInit {
  lastNews: any[];
  popularNews: any[];

  constructor(private _router: Router,
              public _translateService: TranslateService,
              private newsSharedService: NewsSharedService) {
    super(_translateService);
  }

  ngOnInit() {
    this.loadLastNews();
    this.loadPopularNews();
  }

  onLangChange(language: Language): void {
  }

  loadLastNews() {
    this.newsSharedService.getLastNews().subscribe(data => {
      if (data) {
        this.lastNews = data;
      }
    });
  }

  loadPopularNews() {
    this.newsSharedService.getPopularNews().subscribe(data => {
      if (data) {
        this.popularNews = data;
      }
    });
  }

  gotoNews(id) {
    if (id && typeof id === 'string') {
      this._router.navigate(['news', id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/news-list-tabs/news-list-tabs.component.ts